module.exports = __webpack_public_path__ + "static/media/pycs_11.fa69495b.png";